import throttle from 'lodash-es/throttle';

/**
 * Get the person name,slug from the event source polygon (data-name,data-slug attributes)
 */
function getPerson(e: MouseEvent) {
  const { name, slug } = (e.target as any).dataset;
  if (name && slug) {
    return { name, slug };
  }
  return undefined;
}

export function PeopleBanner() {
  const polygons = document.querySelectorAll('polygon');
  const peopleBanner = document.querySelector('.PeopleBanner');
  if (!peopleBanner) {
    return null;
  }

  // Set up tooltip element
  const tooltip = document.createElement('div');
  tooltip.classList.add('PeopleBanner-tooltip');
  peopleBanner.append(tooltip);

  function onMouseOver(e: MouseEvent) {
    const p = getPerson(e);
    if (p) {
      tooltip.innerText = p.name;
      tooltip.style.opacity = '1';
    }
  }

  function onMouseOut(e: MouseEvent) {
    tooltip.style.opacity = '0';
  }

  function onMouseMove(e: MouseEvent) {
    // Offset on Firefox is the offset of the current div not the screen, derfore we need to use layer on firefox.
    // @ts-ignore
    const x = navigator.userAgent.search('Firefox') > -1 ? e.layerX : e.offsetX;
    const y =
      // @ts-ignore
      (navigator.userAgent.search('Firefox') > -1 ? e.layerY : e.offsetY) + 40;
    tooltip.style.transform = `translate(${x}px,${y}px) translateX(-50%)`;
  }

  function onClick(e: MouseEvent) {
    const p = getPerson(e);

    if (p) {
      (window.History as any).pushState(
        null,
        p.name,
        (window as any).SITE_ROOT + '/kontakt/' + p.slug
      );
    }
  }

  polygons.forEach((polygon) => {
    polygon.addEventListener(
      'mousemove',
      throttle(onMouseMove, 5, { trailing: true })
    );
    polygon.addEventListener('mouseover', onMouseOver);
    polygon.addEventListener('mouseout', onMouseOut);
    polygon.addEventListener('click', onClick);
  });
}
